// extracted by mini-css-extract-plugin
module.exports = {"questionViewContainer":"Hh9VwazY","textAreaElement":"Z7VGqseq","inputWrapper":"S16_3rAE","error":"MgmXrhH7","focused":"PDhmleFx","errorLabel":"R2LeHd19"};